import { UIController } from '../../ui/controller';
import { action } from 'mobx';
import { RedirectFunction, RouterState } from 'react-router';
import { EnvModel } from '../../env/model';

export class MasterPageController {
  constructor(private ui: UIController, private env: EnvModel) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    if (!this.env.isServer) {
      const { query } = nextState.location;

      this.env.queryStringCookies.forEach((key) => {
        if (query[key]) {
          const d = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 days;
          const expires = 'expires=' + d.toUTCString();

          document.cookie = `${key}=${query[key]}; ${expires}; path=/; domain=${process.env.ROOT_DOMAIN}`;
        }
      });
    }

    return true;
  };

  onLeave = () => {
    this.ui.hideOverlays();
    this.ui.scrollToTop();
  };
}
